// Minimal theme tokens for the character-builder scaffold.
//
// CLAUDE.md §4.8: the canonical theme system is `S` in App.js, a module-level
// mutated-in-place style object (see App.js:3589 `updateStylesInPlace`).
// `S` is not exportable without refactoring App.js — and that refactor is a
// Phase 1 modularization concern in its own right (see ROADMAP.md appendix,
// "S style singleton mutation-in-place").
//
// For now we read color tokens from `src/features/dashboard/themes/themes.js`
// (already extracted, no App.js dependency) and assemble inline styles
// locally. When the global theme system is properly extracted, this file
// becomes a thin re-export and the builder picks up theme switching for free.

import { THEMES } from '../dashboard/themes/themes';

const theme = THEMES['fantasy-classic'];

export const colors = theme.colors;
export const typography = theme.typography;
export const effects = theme.effects;

// Common style fragments used across the builder. Compose with spread:
//   <div style={{ ...styles.card, padding: 24 }}>
export const styles = {
  page: {
    minHeight: '100vh',
    background: colors.bgPrimary,
    color: colors.textPrimary,
    fontFamily: typography.fontFamily,
    padding: '32px 16px',
    boxSizing: 'border-box',
  },
  container: {
    maxWidth: 1024,
    margin: '0 auto',
  },
  heading: {
    fontFamily: typography.headingFamily,
    color: colors.accentLight,
    textShadow: effects.headingTextShadow,
    margin: 0,
  },
  subheading: {
    color: colors.textSecondary,
    margin: '8px 0 0 0',
    fontWeight: 'normal',
  },
  card: {
    background: colors.bgCard,
    border: effects.cardBorder,
    borderRadius: effects.borderRadiusLg,
    boxShadow: effects.cardShadow,
    padding: 24,
    transition: effects.transition,
  },
  cardHover: {
    boxShadow: effects.cardShadowHover,
    background: colors.bgCardHover,
    transform: 'translateY(-2px)',
  },
  buttonPrimary: {
    background: colors.accent,
    color: colors.textOnAccent,
    border: 'none',
    borderRadius: effects.borderRadius,
    padding: '10px 20px',
    fontFamily: typography.fontFamily,
    fontSize: 14,
    fontWeight: 'bold',
    cursor: 'pointer',
    boxShadow: effects.buttonShadow,
    transition: effects.transition,
  },
  buttonSecondary: {
    background: 'transparent',
    color: colors.accent,
    border: `1px solid ${colors.accent}`,
    borderRadius: effects.borderRadius,
    padding: '10px 20px',
    fontFamily: typography.fontFamily,
    fontSize: 14,
    cursor: 'pointer',
    transition: effects.transition,
  },
  buttonGhost: {
    background: 'transparent',
    color: colors.textSecondary,
    border: 'none',
    padding: '6px 12px',
    fontFamily: typography.fontFamily,
    fontSize: 13,
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  textMuted: {
    color: colors.textMuted,
    fontSize: 12,
  },
  legalFootnote: {
    color: colors.textMuted,
    fontSize: 11,
    lineHeight: 1.5,
    maxWidth: 720,
    margin: '48px auto 0',
    textAlign: 'center',
    fontStyle: 'italic',
  },
};
